// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#body[data-v-29b7a971]{display:-webkit-box;display:-ms-flexbox;display:flex;min-height:100vh;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}main[data-v-29b7a971]{-webkit-box-flex:1;-ms-flex:1;flex:1}.connect-account-button[data-v-29b7a971]:hover  .icon{color:#fff!important}.inbox-count[data-v-29b7a971]{position:relative;bottom:1px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
